// styling
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

const textBase = css<{ $inheritTypography: boolean }>`
  ${({ theme, $inheritTypography }) =>
    $inheritTypography
      ? css`
          font-family: inherit;
          font-size: inherit;
          line-height: inherit;
          font-weight: inherit;
        `
      : typographyToCss(theme.typography.body2)};
  display: block;
  grid-area: 1 / 1 / 2 / 2;

  padding: 0;
  margin: 0;

  border: none;
  outline: none;
  word-break: break-word;
`;

export const Container = styled.div<{ $inheritTypography: boolean }>`
  display: grid;

  &::after {
    ${textBase};
    content: attr(data-replicated-value) ' ';
    white-space: pre-wrap;
    visibility: hidden;
  }
`;

export const TextArea = styled.textarea<{ $inheritTypography: boolean }>`
  ${textBase};

  resize: none;
  overflow: hidden;

  color: inherit;
  background: transparent;

  &::-webkit-input-placeholder {
    opacity: 0.3;
    color: inherit;
  }

  &::-moz-placeholder {
    opacity: 0.3;
    color: inherit;
  }

  &:-ms-input-placeholder {
    opacity: 0.3;
    color: inherit;
  }
`;
